// Abstract globe + supply-chain network centerpiece for the sign-in page (pure SVG, CSS-animated).
const NODES = [
  [300, 120], [420, 90], [520, 150], [600, 240], [560, 340], [450, 380], [330, 350], [250, 260], [380, 230], [480, 260],
];
const LINKS = [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 0], [7, 8], [8, 9], [9, 3], [8, 1], [9, 5], [8, 6]];
const GOLD = new Set([2, 5, 8]);

export function SupplyNetwork({ reduce }) {
  return (
    <svg viewBox="0 0 760 480" className={`hl-network h-full w-full max-h-[420px] ${reduce ? "" : "hl-animate"}`} fill="none" role="img" aria-label="Global supply network">
      <defs>
        <radialGradient id="hl-globe" cx="45%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#EAF2F8" stopOpacity="0.9" />
          <stop offset="70%" stopColor="#377DD3" stopOpacity="0.08" />
          <stop offset="100%" stopColor="#377DD3" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="hl-line" x1="0" x2="1">
          <stop offset="0%" stopColor="#377DD3" stopOpacity="0.15" />
          <stop offset="100%" stopColor="#245FAF" stopOpacity="0.5" />
        </linearGradient>
      </defs>
      <g className="hl-globe-group">
        <circle cx="430" cy="240" r="200" fill="url(#hl-globe)" />
        <circle cx="430" cy="240" r="200" stroke="#377DD3" strokeOpacity="0.22" />
        <ellipse cx="430" cy="240" rx="200" ry="70" stroke="#377DD3" strokeOpacity="0.16" />
        <ellipse cx="430" cy="240" rx="200" ry="140" stroke="#377DD3" strokeOpacity="0.12" />
        <ellipse cx="430" cy="240" rx="70" ry="200" stroke="#377DD3" strokeOpacity="0.16" />
        <ellipse cx="430" cy="240" rx="140" ry="200" stroke="#377DD3" strokeOpacity="0.12" />
        <line x1="230" y1="240" x2="630" y2="240" stroke="#377DD3" strokeOpacity="0.14" />
      </g>
      {LINKS.map(([a, b], i) => (
        <line key={i} x1={NODES[a][0]} y1={NODES[a][1]} x2={NODES[b][0]} y2={NODES[b][1]} stroke="url(#hl-line)" strokeWidth="1.2" className="hl-link" style={{ animationDelay: `${i * 0.4}s` }} />
      ))}
      {NODES.map(([x, y], i) => (
        <g key={i} className="hl-node" style={{ animationDelay: `${i * 0.35}s` }}>
          <circle cx={x} cy={y} r="10" fill={GOLD.has(i) ? "#F5C64D" : "#377DD3"} fillOpacity="0.12" />
          <circle cx={x} cy={y} r="3.5" fill={GOLD.has(i) ? "#F5C64D" : "#377DD3"} />
        </g>
      ))}
      {/* molecular hint */}
      <g stroke="#245FAF" strokeOpacity="0.25" strokeWidth="1">
        <polygon points="120,360 150,343 180,360 180,394 150,411 120,394" fill="#EAF2F8" fillOpacity="0.6" />
        <line x1="180" y1="360" x2="205" y2="346" /><circle cx="207" cy="345" r="3" fill="#F5C64D" stroke="none" />
        <line x1="120" y1="394" x2="95" y2="408" /><circle cx="93" cy="409" r="3" fill="#377DD3" stroke="none" />
        <polygon points="640,80 660,69 680,80 680,102 660,113 640,102" fill="#EAF2F8" fillOpacity="0.6" />
        <line x1="680" y1="80" x2="700" y2="70" /><circle cx="702" cy="69" r="2.5" fill="#F5C64D" stroke="none" />
      </g>
    </svg>
  );
}
